import React, { Component } from 'react'
import { Button } from 'loyal-react'

class DocumentAnalysis extends Component {
  render () {
    return (
      <div className='col-12 row mx-0 px-0'>
        <div className='col-12 px-0 pb-2'>
          <p className='txt-body-sm txt-bold color-brand-1'>Você possui uma solicitação de cadastro em aberto.</p>
          <p className='txt-body-sm mt-1'>Realizada em <strong>19/06/2019</strong> às <strong>10:37</strong> com número de protocolo <strong>00262816</strong>.</p>
          <p className='txt-body-sm'>Sua solicitação será respondida por e-mail em até 72 horas.</p>
          <div className='col-12 col-md-3 px-0 pt-2'>
            <Button
              className='btn btn-sm btn-featured txt-button txt-center txt-font-body-bold'
              text='VERIFIQUE AGORA'
              onClick={() => {}}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default DocumentAnalysis



// WEBPACK FOOTER //
// ./src/Participant/TwoStepVerification/DocumentAnalysis/DocumentAnalysis.js